/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Tab, Tabs } from "@nordcloud/gnui";
import { useTabsWithUrl } from "~/hooks";
import { Ec2AdvancedData, Metadata } from "../components";
import { UtilizationTab } from "./UtilizationTab";

type Props = {
  metadata: Metadata[];
  nid: string;
};

export function ReservationTabs({ metadata, nid }: Props) {
  const { activeTab, setActiveTab } = useTabsWithUrl();

  return (
    <Tabs step={activeTab} handleTab={setActiveTab}>
      <Tab heading="Utilization">
        <UtilizationTab nid={nid} />
      </Tab>
      <Tab heading="Advanced Data">
        <Ec2AdvancedData metadata={metadata} nid={nid} />
      </Tab>
    </Tabs>
  );
}
